/* Same-page native Shopify enquiries. No client-side success simulation. */
(() => {
  const init = () => {
    const dialog = document.querySelector('[data-wei-quick-quote]');
    if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    const form = dialog.querySelector('form');
    let returnFocus, contextKey = '';
    const field = name => form.elements.namedItem(`contact[${name}]`);
    const value = (name, text) => { const input = field(name); if (input) input.value = text || ''; };
    const markSeen = () => { try { sessionStorage.setItem('wei-inquiry-prompt-v1', 'shown'); } catch {} };
    const pageProduct = () => {
      const root = document.querySelector('[data-wei-product]');
      if (!root) return null;
      try {
        const data = JSON.parse(root.querySelector('[data-wei-variants]').textContent);
        const selected = root.querySelector('[data-wei-variant-select]')?.value || root.dataset.variantId;
        const variant = data.variants.find(item => String(item.id) === String(selected)) || data.variants[0];
        return { title: data.title, handle: data.handle, id: root.dataset.productId || field('Product ID')?.value, variant: variant?.id, sku: variant?.sku, option: variant?.title };
      } catch { return null; }
    };
    const cardProduct = card => {
      const title = card.querySelector('.ap-title,.woocommerce-loop-product__title,.product-title')?.textContent.trim();
      return { title, handle: card.dataset.productHandle, id: card.dataset.productId, variant: card.dataset.variantId, sku: card.dataset.productSku || card.querySelector('[data-wei-variant-sku]')?.textContent.trim() || card.querySelector('.yueshi-part-sku,.home-part-sku')?.textContent.replace(/^REF[.\s]*/i, '').trim() };
    };
    const setProduct = product => {
      if (!product?.title) return;
      const key = [product.id || product.handle || product.title, product.variant || ''].join(':');
      if (key === contextKey) return;
      contextKey = key;
      value('Product / Model', product.title + (product.option && product.option !== 'Default Title' ? ` — ${product.option}` : ''));
      value('Quantity', '1');
      value('Product ID', product.id);
      value('Variant ID', product.variant);
      value('SKU', product.sku);
      value('Product URL', product.handle ? new URL(`/products/${encodeURIComponent(product.handle)}`, location.origin).href : location.href);
    };
    const open = (trigger, product) => {
      returnFocus = trigger || document.activeElement;
      setProduct(product);
      markSeen();
      document.querySelector('[data-wei-inquiry-popup][open]')?.close();
      const legacyDialog = trigger?.closest('.delivery-modal');
      legacyDialog?.closeDelivery?.();
      requestAnimationFrame(() => {
        if (!dialog.open) dialog.showModal();
        (field('Product / Model').value ? field('Quantity') : field('Product / Model')).focus({ preventScroll: true });
      });
    };
    // Capture before the imported inquiry-list handler on document.
    window.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      let trigger = target.closest('[data-wei-open-quote]');
      const cardButton = target.closest('.add_to_cart_button,.ap-readmore-box a,.yueshi-part-inquiry');
      const card = cardButton?.closest('[data-product-handle]');
      if (!trigger && card && /^(inquiry|inquire|request a quote|request quote)$/i.test(cardButton.textContent.trim())) trigger = cardButton;
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open(trigger, card ? cardProduct(card) : pageProduct());
    }, true);
    dialog.querySelector('[data-wei-close-quote]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { const target = returnFocus?.isConnected && returnFocus.getClientRects().length ? returnFocus : document.querySelector('.wei-contact-dock__quote'); target?.focus({ preventScroll: true }); });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('button,a[href],input,textarea,select,[tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
      const first = items[0], last = items.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    form.addEventListener('submit', () => {
      const current = new URL(location.href);
      current.searchParams.delete('contact_posted');
      current.searchParams.set('wei_quote', '1');
      current.hash = 'wei-quick-quote';
      const returnTo = form.elements.namedItem('return_to');
      if (returnTo) returnTo.value = current.pathname + current.search + current.hash;
      value('Page URL', location.href);
      if (!field('body').value.trim()) value('body', `Quotation request: ${field('Product / Model').value}. Quantity: ${field('Quantity').value}.`);
    }, true);
    document.querySelector('[data-wei-whatsapp]')?.addEventListener('click', event => {
      const product = pageProduct();
      if (!product) return;
      const link = event.currentTarget;
      const url = new URL(link.href);
      const reference = product.sku ? ` SKU: ${product.sku}.` : '';
      const option = product.option && product.option !== 'Default Title' ? ` (${product.option})` : '';
      url.searchParams.set('text', `Hello YUESHIGUOJI, I would like a quotation for ${product.title}${option}.${reference} ${location.href}`);
      link.href = url.href;
    });
    const result = dialog.querySelector('[data-wei-quote-success],[data-wei-quote-error]');
    if (new URLSearchParams(location.search).get('wei_quote') === '1' && result) {
      markSeen();
      dialog.showModal();
      result.focus({ preventScroll: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
